import { createContext, useContext } from "react";
import {
  DayOfWeek,
  LocaleSettingsResult,
  MeasurementSystem,
} from "@repo/rq-api-public";
import { DynamicDateFormatter } from "../utils/dynamic-date-formatter";

export const FALLBACK_LOCALE = LocaleSettingsResult.fromJS({
  culture: "en-US",
  country: "US",
  language: "en",
  timeZoneInfoId: "America/New_York",
  measurementSystem: MeasurementSystem.Imperial,
  dateFormat: { pattern: "M/d/yyyy", locale: "en-US", separator: "/" },
  timeFormat: {
    pattern: "h:mm a",
    use12Hour: true,
    showPeriod: true,
    showLeadingZero: false,
  },
  currencyFormat: {
    code: "USD",
    symbol: "$",
    locale: "en-US",
    decimalPlaces: 2,
    symbolPosition: "before",
  },
  measurementUnits: {
    lengthUnit: "ft",
    volumeUnit: "gal",
    fuelConsumptionUnit: "gal/hr",
    distanceUnit: "mi",
    speedUnit: "mph",
    cabinLabel: "Stateroom",
  },
  weekStartDay: DayOfWeek.Sunday,
});

type FormattersContextValue = {
  dateFormatter: DynamicDateFormatter;
  locale: LocaleSettingsResult;
};

export const FormattersContext = createContext<
  FormattersContextValue | undefined
>(undefined);

export function useFormatters() {
  const context = useContext(FormattersContext);
  if (!context)
    throw new Error("useFormatters must be used within a FormattersProvider");
  return context;
}
